<div id="content-section">
    <div id="content-main" class="responsive-content-main" [ngStyle]="{ 'margin-right': sidebarMaximized ? '370px' : '270px' }">
        <div id="content-sidebar" [ngClass]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [ngStyle]="{ width: sidebarMaximized ? '350px' : '250px' }" style="position: fixed; right: 20px">
            <div class="sticky-top">
                <small class="bg-white">
                  <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
                    <i class="fas" [ngClass]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
                  </a>
                </small>
            </div>
            <div class="text-center pagination-small-margin pagination-center">
                <pagination
                (pageChanged)="search($event, null)"
                class="pagination-sm"
                [boundaryLinks]="true"
                [totalItems]="count"
                [maxSize]="5"
                [itemsPerPage]="searchOptions.per_page"
                [(ngModel)]="searchParams.page"
                previousText="&lsaquo;"
                nextText="&rsaquo;"
                firstText="&laquo;"
                lastText="&raquo;"
                ></pagination>
            </div>
            <div class="text-center pt-1">
                <app-pagination-count
                    [count]="count"
                    singularName="Entry Group"
                    pluralName="Entry Groups"
                ></app-pagination-count>
            </div>
            <hr class="my-1" />
            <div class="clearfix"></div>
            <div class="sticky-top bg-white">
                <h5 class="pt-2">
                <div class="pull-right float-right">
                    <app-clear-search-btn [searching]="searching" (onClick)="clearSearch()"></app-clear-search-btn>
                </div>
                <span>
                    Search&nbsp;&nbsp;
                    <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? (searchParams.page = 1) && search(null, true) : ''">
                        <i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i>
                    </a>
                </span>
                </h5>
                <hr class="my-1" />
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="entry_group_id">Entry Group ID:</label>
                        <input class="form-control" type="number" id="entry_group_id" name="entry_group_id" [(ngModel)]="searchParams.id" [ngModelOptions]="{ standalone: true }">
                    </div>
                    <div class="form-group">
                        <label for="entry-group-type">Entry Group Type:</label>
                        <select class="form-control" id="entry-group-type" [(ngModel)]="searchParams.entry_group_type_id" [ngModelOptions]="{ standalone: true }">
                            <option [value]=""></option>
                            <option [value]="entryGroupType.value" *ngFor="let entryGroupType of searchOptions.entry_group_types">{{entryGroupType.label}}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <div class="custom-control custom-checkbox" (click)="searchParams.parents_only = !searchParams.parents_only">
                            <input type="checkbox" class="custom-control-input" [checked]="searchParams.parents_only" />
                            <label class="custom-control-label">Only Parent Groups</label>
                        </div>
                    </div>
                    <div class="form-group">
                        <app-search-btn [searching]="searching" (onClick)="searchParams.page = 1; search(null, true)"></app-search-btn>
                    </div>
                </div>
            </div>
        </div>
        <div id="content-inner" class="responsive-content-inner" style="padding: 0px 20px 10px 20px">
            <div class="container-shadow px-3 pb-4">
                <h2 class="pt-4 text-center">Entry Groups</h2>
                <hr class="mt-1 mb-2" />
                <a class='btn btn-outline-primary' [href]="'/entry_groups/' + latestEntryGroupId" *ngIf='latestEntryGroupId'>Newest Root Group</a>
                <div class="row p-4" style="overflow-x:auto;transform: rotateX(180deg);">
                    <table class="table" style="transform: rotateX(180deg);">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Type</th>
                                <th>Reversed</th>
                                <th>Description</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let entryGroup of entryGroups">
                                <td><a [href]="'/entry_groups/' + entryGroup.id">{{entryGroup.id}}</a></td>
                                <td><a [href]="'/entry_group_type/' + entryGroup.entry_group_type_id">{{entryGroup.entry_group_type.name}}</a></td>
                                <td class='text-center'><span class="text-danger"><i *ngIf="entryGroup.is_reversed" class="fas fa-times-circle"></i></span></td>
                                <td>{{entryGroup.description}}</td>
                                <td>{{entryGroup.date}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<app-sidebar-toggle-btn [sidebarOpen]="sidebarOpen" (onClick)="sidebarOpen = !sidebarOpen"></app-sidebar-toggle-btn>